export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT"
export const CHECK_AUTH = "CHECK_AUTH";